import { render, staticRenderFns } from "./showCode.vue?vue&type=template&id=7620fbcd&scoped=true&"
import script from "./showCode.vue?vue&type=script&lang=js&"
export * from "./showCode.vue?vue&type=script&lang=js&"
import style0 from "./showCode.vue?vue&type=style&index=0&id=7620fbcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620fbcd",
  null
  
)

export default component.exports